
const mapMetadataKey = 'its.appdev.map.decorator';
export function mappable(type: string) {
  return (target: object, propertyKey: string | symbol) => {
    const d = Reflect.get(target, mapMetadataKey) || {};
    d[propertyKey] = type;
    Reflect.set(target, mapMetadataKey, d);
  };
}

export function getMappableProperties(target: unknown): {
  [propKey: string]: string;
} {
  return Reflect.get(target as object, mapMetadataKey) || {};
}
